<template>
  <div class="auth-wrapper auth-v2">
    <b-row class="auth-inner m-0">

      <!-- Left Text-->
      <b-col
        lg="8"
        class="d-none d-lg-flex align-items-center p-5 background-custom"
        :style="`background-image: url('${imgUrl}');`"
      >
      </b-col>
      <!-- /Left Text-->

      <!-- Login-->
      <b-col
        lg="4"
        class="d-flex align-items-center auth-bg px-2 p-lg-5"
      >
        <b-col
          sm="8"
          md="6"
          lg="12"
          class="px-xl-2 mx-auto"
        >
          <div class="text-center mb-3">
            <b-img
                :src="appLogoImage"
                alt="logo"
                class="login-logo img-fluid"
            />
          </div>
          <b-card-title
            title-tag="h2"
            class="font-weight-bold mb-1 text-center"
          >
            ¡Bienvenido a Shireo! 👋
          </b-card-title>

          <!-- form -->
          <validation-observer ref="loginValidation">
            <b-form
              class="auth-login-form mt-2"
              @submit.prevent="handleSubmit"
              @keydown.enter="handleSubmit"
            >
              <!-- email -->
              <b-form-group
                label="Usuario"
                label-for="login-email"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Usuario"
                  rules="required"
                >
                  <b-form-input
                    id="login-email"
                    v-model="userEmail"
                    :state="errors.length > 0 ? false:null"
                    name="login-email"
                    placeholder=""
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <!-- forgot password -->
              <b-form-group>
                <div class="d-flex justify-content-between">
                  <label for="login-password">Contraseña</label>
                </div>
                <validation-provider
                  #default="{ errors }"
                  name="Password"
                  rules="required"
                >
                  <b-input-group
                    class="input-group-merge"
                    :class="errors.length > 0 ? 'is-invalid':null"
                  >
                    <b-form-input
                      id="login-password"
                      v-model="password"
                      :state="errors.length > 0 ? false:null"
                      class="form-control-merge"
                      :type="passwordFieldType"
                      name="login-password"
                      placeholder="············"
                    />
                    <b-input-group-append is-text>
                      <feather-icon
                        class="cursor-pointer"
                        :icon="passwordToggleIcon"
                        @click="togglePasswordVisibility"
                      />
                    </b-input-group-append>
                  </b-input-group>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
              <!-- submit buttons -->
              <b-button
                type="submit"
                variant="primary"
                block
              >
                Iniciar sesión
              </b-button>
              <div class="text-center mt-2" >
                <b-link class="cursor-pointer" id="show-btn click" @click="$bvModal.show('forgot-password')">
                  <small>Recuperar contraseña</small>
                </b-link>
              </div>
            </b-form>
          </validation-observer>
        </b-col>
      </b-col>
    <!-- /Login-->
    </b-row>
    <b-modal id="forgot-password" :hide-footer="true" size="lg">
      <validation-observer ref="forgotPassword">
        <b-card-title title-tag="h1" class="font-weight-bolder mb-1 text-center">
          Restablecer contraseña
        </b-card-title>
        <div class="asignar-trabajos-modal">
          <b-row class="justify-content-center middle" align-v="center">
            <b-col class="text-center" lg="10">
              <span>Introduce el usuario que tienes asociado a tu cuenta y te mandaremos las instrucciones dónde podrás cambiar tu contraseña.</span>
            </b-col>
          </b-row>

          <b-form class="mt-2" @submit.prevent="handleSubmitForgotPassword">
            <b-container class="pl-3 pr-3">
              <b-row class="justify-content-center middle" align-v="center">
                <b-col lg="8">
                  <validation-provider #default="{ errors }" :name="'Usuario'" rules="required">
                    <b-form-group :label="'Usuario'" label-for="forgot-email">
                      <b-form-input id="login-email" v-model="userEmailForgot"
                                    :state="errors.length > 0 ? false : null" name="login-email-forgot" />
                    </b-form-group>
                    <small ref="errorField" class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-col>
              </b-row>
              <b-row class="text-center mb-3">
                <b-col>
                  <b-button type="submit" variant="primary" class="mt-1 mr-1 text-uppercase">
                    Enviar
                  </b-button>
                </b-col>
              </b-row>
            </b-container>
          </b-form>
        </div>
      </validation-observer>
    </b-modal>
  </div>
</template>

<script>
/* eslint-disable global-require */
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BContainer, BRow, BCol, BLink, BFormGroup, BFormInput, BInputGroupAppend, BInputGroup, BFormCheckbox, BCardText, BCardTitle, BImg, BForm, BButton,
} from 'bootstrap-vue'
import { required, email } from '@validations'
import { togglePasswordVisibility } from '@core/mixins/ui/forms'
import store from '@/store/index'
import { mapActions } from 'vuex'
import { $themeConfig } from '../../themeConfig'

export default {
  components: {
    BRow,
    BCol,
    BLink,
    BFormGroup,
    BFormInput,
    BInputGroupAppend,
    BInputGroup,
    BFormCheckbox,
    BCardText,
    BCardTitle,
    BImg,
    BForm,
    BButton,
    BContainer,
    ValidationProvider,
    ValidationObserver,
  },
  mixins: [togglePasswordVisibility],
  data() {
    return {
      status: '',
      password: '',
      userEmail: '',
      userEmailForgot: '',
      sideImg: require('@/assets/images/pages/shireo-login.jpg'),
      // validation rulesimport store from '@/store/index'
      required,
      email,
      recoverButtonTimeout: null,
      showForgotPassword: false,
    }
  },
  computed: {
    passwordToggleIcon() {
      return this.passwordFieldType === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
    imgUrl() {
      if (store.state.appConfig.layout.skin === 'dark') {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.sideImg = require('@/assets/images/pages/shireo-login.jpg')
        return this.sideImg
      }
      return this.sideImg
    },
  },
  methods: {
    ...mapActions({
      login: 'auth/login',
      recoverPassword: 'auth/recoverPassword',
    }),
    handleSubmit() {
      this.$refs.loginValidation.validate().then(success => {
        if (success) {
          const { userEmail, password, rememberme } = this
          if (userEmail && password) {
            this.login({ email: userEmail, password, rememberme })
          }
        }
      })
    },
    handleSubmitForgotPassword() {
      if (this.recoverButtonTimeout) {
        clearTimeout(this.recoverButtonTimeout)
      }

      this.recoverButtonTimeout = setTimeout(() => {
        this.$refs.forgotPassword.validate().then(success => {
          if (success) {
            const { userEmailForgot } = this
            if (userEmailForgot) {
              this.recoverPassword({ username: userEmailForgot })
            }
          }
        })
      }, 500)
    },
  },
  setup() {
    // App Name
    const { appName, appLogoImage } = $themeConfig.app
    return {
      appName,
      appLogoImage,
    }
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-auth.scss';
</style>
